import { GridStateSettings, useStoredSettings } from '../settings';
import { useEventCommonStoreRef, useUserStoreRef } from '@/stores';
import { CustomGridState } from '@/components/Grid/Classes/CustomGridState';
import { defineStore } from 'pinia';

export const useGridSettings = defineStore('gridsettings', () => {
    // We need to get the event from the event store
    const { Event } = useEventCommonStoreRef();

    const { user } = useUserStoreRef();

    let settings: GridStateSettings = new GridStateSettings();

    /**
     * We save a new gridsate to the settings
     * @param state
     */
    const saveState = (state: CustomGridState) => {
        // We need to add the Forbund to the state key so we can group by Forbund later
        state.gridkey = `${state.gridkey}-${Event.value?.FederationID}`;

        // Update or add the new state to settings
        const index = settings.gridStates.findIndex((x) => x.gridkey === state.gridkey);
        if (index !== -1) {
            settings.gridStates[index] = state;
        } else {
            settings.gridStates.push(state);
        }

        if (user.value?.ID !== undefined) {
            useStoredSettings().SaveSettings<GridStateSettings>(GridStateSettings, settings, null, user.value.ID);
        }
    };

    /**
     * Get the state from the settings based on the gridkey group by Forbund
     * @param gridkey
     * @returns GridState
     */
    const getState = (gridkey: string): CustomGridState | null => {
        const normalizedGridkey = `${gridkey}-${Event.value?.FederationID}`;
        return settings.gridStates.find((x) => x.gridkey === normalizedGridkey) ?? null;
    };

    const loadSettings = async (userid: number) => {
        settings = (await useStoredSettings().GetSettings(GridStateSettings, null, userid)) ?? new GridStateSettings();
    };

    return {
        SaveState: saveState,

        GetState: getState,

        LoadSettings: loadSettings,
    };
});
